/* GarajMoto: vehicle results page controller */
(function () {
  'use strict';
  function boot() {
    var G = window.GMV, root = document.querySelector('.gmr');
    if (!G || !root) return;
    var $ = function (s) { return root.querySelector(s); };
    var body = $('#gmr-body');
    var params = new URLSearchParams(location.search);
    var S = { mid: params.get('m'), cat: params.get('c') || '', tab: params.get('t') === 'u' ? 'u' : 'c', q: params.get('q') || '', type: '', sort: 'rel', shown: 24 };
    var MODEL = null, MAP = null, META = null;
    var TIER = { s: ['Dedicat modelului', 's'], l: ['Compatibil', 'l'], u: ['Universal', 'u'] };

    if (!S.mid) { var sv = G.saved(); if (sv) S.mid = sv.modelId; }
    setupModelPicker();
    if (!S.mid) { $('#gmr-title').textContent = 'Alege scuterul tău'; body.innerHTML = '<div class="gmr-empty">Scrie modelul scuterului în câmpul de mai sus (ex. <b>Vivacity 50</b>, <b>Liberty 125</b>, <b>Booster</b>).</div>'; return; }

    Promise.all([G.meta(), G.model(S.mid), G.findModel(S.mid)]).then(function (r) {
      META = r[0]; MAP = r[1]; MODEL = r[2];
      if (!MODEL) { body.innerHTML = '<div class="gmr-empty">Nu am găsit piese pentru acest model. Încearcă alt model.</div>'; return; }
      G.save(MODEL.brand, MODEL.id, MODEL.d);
      $('#gmr-title').textContent = MODEL.brand + ' ' + MODEL.d;
      var ncat = Object.keys(MAP).length;
      $('#gmr-sub').textContent = MODEL.n + ' piese compatibile în ' + ncat + (ncat === 1 ? ' categorie' : ' categorii') + (G.modelMeta(MODEL) ? ' · ' + G.modelMeta(MODEL) : '');
      document.title = 'Piese ' + MODEL.brand + ' ' + MODEL.d + ' | GarajMoto';
      render();
    }).catch(function () { body.innerHTML = '<div class="gmr-empty">Eroare la încărcare. Reîncarcă pagina.</div>'; });

    function syncUrl() {
      var p = new URLSearchParams(); p.set('m', S.mid); if (S.cat) p.set('c', S.cat); if (S.tab === 'u') p.set('t', 'u'); if (S.q) p.set('q', S.q);
      history.replaceState(null, '', location.pathname + '?' + p.toString());
    }
    function catName(slug) { for (var i = 0; i < META.cats.length; i++) if (META.cats[i][0] === slug) return META.cats[i][1]; return slug; }
    function render() { syncUrl(); if (S.cat) renderCategory(); else if (S.q) renderSearch(); else renderHome(); window.scrollTo({ top: root.offsetTop - 20, behavior: 'smooth' }); }

    function searchBar() {
      return '<div class="gmr-searchbar"><input type="search" id="gmr-q" placeholder="Caută printre piesele scuterului: ex. curea, variator, cilindru..." value="' + G.esc(S.q) + '"></div>';
    }
    function bindSearch() {
      var inp = $('#gmr-q'); if (!inp) return; var t;
      inp.addEventListener('input', function () { clearTimeout(t); t = setTimeout(function () { S.q = inp.value.trim(); S.cat = ''; S.shown = 24; if (S.q) renderSearch(true); else renderHome(); syncUrl(); }, 250); });
    }

    function renderHome() {
      var cats = META.cats.filter(function (c) { return MAP[c[0]]; }).sort(function (a, b) { return MAP[b[0]].length - MAP[a[0]].length; });
      var tiles = cats.map(function (c) { return '<button class="gmr-cat" data-cat="' + c[0] + '"><span>' + G.esc(c[1]) + '</span><span class="gmr-cat__n">' + MAP[c[0]].length + '</span></button>'; }).join('');
      var uni = META.cats.filter(function (c) { return META.uni[c[0]]; }).map(function (c) { return '<button class="gmr-cat gmr-cat--muted" data-cat="' + c[0] + '" data-tab="u"><span>' + G.esc(c[1]) + '</span><span class="gmr-cat__n">' + META.uni[c[0]] + '</span></button>'; }).join('');
      body.innerHTML = searchBar() + '<div class="gmr-cats">' + tiles + '</div>' +
        '<h2 class="gmr-h2">Produse universale</h2><p class="gmr-note">Se potrivesc la aproape orice scuter (ulei, becuri, șuruburi, scule, echipament). Sunt afișate separat ca să nu încurce căutarea.</p>' +
        '<div class="gmr-cats" style="margin-top:10px">' + uni + '</div>';
      bindSearch();
      body.querySelectorAll('[data-cat]').forEach(function (b) { b.addEventListener('click', function () { S.cat = b.dataset.cat; S.tab = b.dataset.tab === 'u' ? 'u' : (MAP[S.cat] ? 'c' : 'u'); S.type = ''; S.shown = 24; S.q = ''; render(); }); });
    }

    function rowsFor(cat, tab) {
      return G.cat(cat).then(function (rows) {
        var idx = tab === 'u' ? rows.map(function (r, i) { return r[7] === 'u' ? i : -1; }).filter(function (i) { return i > -1; }) : (MAP[cat] || []);
        return idx.map(function (i) { return rows[i]; });
      });
    }
    function matchQ(r, toks) { var k = r._k || (r._k = G.norm(r[1] + ' ' + r[2])); for (var i = 0; i < toks.length; i++) if (k.indexOf(toks[i]) === -1) return false; return true; }
    function sortRows(list) {
      if (S.sort === 'pa') list.sort(function (a, b) { return (b[8] - a[8]) || (a[4] - b[4]); });
      else if (S.sort === 'pd') list.sort(function (a, b) { return (b[8] - a[8]) || (b[4] - a[4]); });
      else list.sort(function (a, b) { return (b[8] - a[8]) || (a[3] - b[3]); });
      return list;
    }

    function renderSearch(keepFocus) {
      var cats = Object.keys(MAP), toks = G.norm(S.q).split(' ').filter(Boolean);
      if (!keepFocus) body.innerHTML = searchBar() + '<div id="gmr-res"><div class="gmr-loading">Căutăm...</div></div>', bindSearch();
      else if (!$('#gmr-res')) { body.insertAdjacentHTML('beforeend', '<div id="gmr-res"></div>'); body.querySelectorAll('.gmr-cats,.gmr-h2,.gmr-note').forEach(function (e) { e.remove(); }); }
      Promise.all(cats.map(function (c) { return rowsFor(c, 'c'); })).then(function (all) {
        var list = sortRows([].concat.apply([], all).filter(function (r) { return matchQ(r, toks); }));
        var box = $('#gmr-res');
        box.innerHTML = '<div class="gmr-bar"><span class="gmr-count">' + list.length + ' piese compatibile pentru „' + G.esc(S.q) + '”</span></div><div class="gmr-grid"></div>';
        if (!list.length) box.innerHTML = '<div class="gmr-empty">Nicio piesă compatibilă pentru „' + G.esc(S.q) + '”. Verifică și <a href="/search?q=' + encodeURIComponent(S.q) + '">toate produsele</a>.</div>';
        else paint(box, list);
      });
    }

    function renderCategory() {
      body.innerHTML = '<div class="gmr-loading">Se încarcă...</div>';
      Promise.all([rowsFor(S.cat, 'c'), rowsFor(S.cat, 'u')]).then(function (r) {
        var comp = r[0], uni = r[1], base = S.tab === 'u' ? uni : comp;
        var types = {}; base.forEach(function (x) { types[x[2]] = (types[x[2]] || 0) + 1; });
        var tkeys = Object.keys(types).sort(function (a, b) { return types[b] - types[a]; });
        var html = '<div class="gmr-bar"><button class="gmr-back" id="gmr-back">← Toate categoriile</button><strong>' + G.esc(catName(S.cat)) + '</strong></div>' +
          '<div class="gmr-bar"><div class="gmr-tabs">' +
          '<button class="gmr-tab' + (S.tab === 'c' ? ' is-on' : '') + '" data-tab="c">Compatibile cu scuterul tău (' + comp.length + ')</button>' +
          '<button class="gmr-tab' + (S.tab === 'u' ? ' is-on' : '') + '" data-tab="u">Universale (' + uni.length + ')</button></div>' +
          '<div class="gmr-tools"><input type="search" id="gmr-fq" placeholder="Filtrează în listă..."><select id="gmr-sort"><option value="rel">Cele mai potrivite</option><option value="pa">Preț crescător</option><option value="pd">Preț descrescător</option></select></div></div>';
        if (tkeys.length > 1) html += '<div class="gmr-chips"><button class="gmr-chip' + (S.type ? '' : ' is-on') + '" data-type="">Toate (' + base.length + ')</button>' + tkeys.map(function (t) { return '<button class="gmr-chip' + (S.type === t ? ' is-on' : '') + '" data-type="' + G.esc(t) + '">' + G.esc(t) + ' (' + types[t] + ')</button>'; }).join('') + '</div>';
        if (S.tab === 'c' && !comp.length) html += '<div class="gmr-empty">Nu avem piese dedicate acestui model în această categorie. Vezi fila <b>Universale</b>.</div>';
        html += '<div id="gmr-res"></div>';
        body.innerHTML = html;
        $('#gmr-sort').value = S.sort;
        var fq = $('#gmr-fq');
        function update() {
          var toks = G.norm(fq.value).split(' ').filter(Boolean);
          var list = base.filter(function (x) { return (!S.type || x[2] === S.type) && (!toks.length || matchQ(x, toks)); });
          sortRows(list); paint($('#gmr-res'), list);
        }
        $('#gmr-back').addEventListener('click', function () { S.cat = ''; S.type = ''; render(); });
        body.querySelectorAll('.gmr-tab').forEach(function (b) { b.addEventListener('click', function () { S.tab = b.dataset.tab; S.type = ''; S.shown = 24; render(); }); });
        body.querySelectorAll('.gmr-chip').forEach(function (b) { b.addEventListener('click', function () { S.type = b.dataset.type; S.shown = 24; body.querySelectorAll('.gmr-chip').forEach(function (x) { x.classList.toggle('is-on', x === b); }); update(); }); });
        $('#gmr-sort').addEventListener('change', function (e) { S.sort = e.target.value; S.shown = 24; update(); });
        var t; fq.addEventListener('input', function () { clearTimeout(t); t = setTimeout(function () { S.shown = 24; update(); }, 200); });
        update();
      });
    }

    function card(r) {
      var tier = TIER[r[7]], img = G.img(r[6], 360);
      return '<a class="gmr-card" href="/products/' + encodeURIComponent(r[0]) + '" data-h="' + G.esc(r[0]) + '">' +
        '<div class="gmr-card__img">' + (img ? '<img loading="lazy" src="' + img + '" alt="' + G.esc(r[1]) + '">' : '<span>🛵</span>') + '</div>' +
        '<div class="gmr-card__b"><span class="gmr-badge gmr-badge--' + tier[1] + '">' + tier[0] + '</span><div class="gmr-card__t">' + G.esc(r[1]) + '</div>' +
        '<div class="gmr-card__p" data-p>' + G.money(r[4]) + (r[5] ? '<s>' + G.money(r[5]) + '</s>' : '') + '</div>' + (r[8] ? '' : '<div class="gmr-card__na">Stoc epuizat</div>') + '</div></a>';
    }
    function paint(box, list) {
      var grid = box.querySelector('.gmr-grid');
      if (!grid) { box.innerHTML = '<div class="gmr-grid"></div>'; grid = box.querySelector('.gmr-grid'); }
      if (!list.length) { box.innerHTML = '<div class="gmr-empty">Niciun produs pentru filtrul ales.</div>'; return; }
      grid.innerHTML = list.slice(0, S.shown).map(card).join('');
      refreshLive(grid);
      var old = box.querySelector('.gmr-more'); if (old) old.remove();
      if (list.length > S.shown) {
        var b = document.createElement('button'); b.className = 'gmr-more'; b.textContent = 'Arată mai multe (' + (list.length - S.shown) + ' rămase)';
        b.addEventListener('click', function () { S.shown += 24; paint(box, list); });
        box.appendChild(b);
      }
    }
    /* keep price/stock fresh from Shopify for the visible cards */
    function refreshLive(grid) {
      grid.querySelectorAll('.gmr-card:not([data-live])').forEach(function (a) {
        a.setAttribute('data-live', '1');
        fetch('/products/' + encodeURIComponent(a.dataset.h) + '.js').then(function (r) { return r.ok ? r.json() : null; }).then(function (p) {
          if (!p) return;
          var pr = a.querySelector('[data-p]'), cmp = p.compare_at_price && p.compare_at_price > p.price ? p.compare_at_price : 0;
          pr.innerHTML = G.money(p.price / 100) + (cmp ? '<s>' + G.money(cmp / 100) + '</s>' : '');
          var na = a.querySelector('.gmr-card__na');
          if (!p.available && !na) a.querySelector('.gmr-card__b').insertAdjacentHTML('beforeend', '<div class="gmr-card__na">Stoc epuizat</div>');
          if (p.available && na) na.remove();
        }).catch(function () {});
      });
    }

    function setupModelPicker() {
      var inp = $('#gmr-model-q'), list = $('#gmr-model-list'), items = [], hl = -1;
      function show() {
        G.models().then(function (all) {
          var q = inp.value.trim();
          items = q.length < 2 ? [] : G.searchModels(all, q, null, 40);
          list.innerHTML = items.length ? items.map(function (m, i) { return '<div class="gmr-opt" data-i="' + i + '">' + G.esc(m.brand + ' ' + m.d) + '<small>' + [G.modelMeta(m), m.n + ' piese'].filter(Boolean).join(' · ') + '</small></div>'; }).join('')
            : (q.length < 2 ? '<div class="gmr-opt"><small>Scrie cel puțin 2 caractere</small></div>' : '<div class="gmr-opt"><small>Niciun model găsit</small></div>');
          list.classList.add('is-open'); hl = -1;
          list.querySelectorAll('[data-i]').forEach(function (el) { el.addEventListener('mousedown', function (e) { e.preventDefault(); pick(items[+el.dataset.i]); }); });
        });
      }
      function pick(m) { G.save(m.brand, m.id, m.d); location.href = G.url(m.id); }
      inp.addEventListener('input', show); inp.addEventListener('focus', show);
      inp.addEventListener('blur', function () { setTimeout(function () { list.classList.remove('is-open'); }, 150); });
      inp.addEventListener('keydown', function (e) {
        var els = list.querySelectorAll('[data-i]');
        if (e.key === 'ArrowDown') { e.preventDefault(); hl = Math.min(els.length - 1, hl + 1); }
        else if (e.key === 'ArrowUp') { e.preventDefault(); hl = Math.max(0, hl - 1); }
        else if (e.key === 'Enter') { e.preventDefault(); if (items[hl > -1 ? hl : 0]) pick(items[hl > -1 ? hl : 0]); return; }
        els.forEach(function (el, i) { el.classList.toggle('is-hl', i === hl); });
      });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
